import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll the window to top
    window.scrollTo(0, 0);
    
    // Also handle cases where a specific element might be scrolling (like .home-container)
    const homeContainer = document.querySelector('.home-container');
    if (homeContainer) {
      homeContainer.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
